import { Badge } from '@/shared/ui/badge'
import { Client } from '@monorepo/functions/src/types/client'

const COLOR_BY_CLASSIFICATION: { [key in Client['classification']]: string } = {
    VIP: 'bg-purple-200 text-purple-800',
    normal: 'bg-gray-200 text-gray-800',
    staff: 'bg-green-200 text-green-800',
}

const LABEL_BY_CLASSIFICATION: { [key in Client['classification']]: string } = {
    VIP: 'VIP',
    normal: 'Normal',
    staff: 'Staff',
}

export const ClassificationBadge = ({ classification }: { classification: Client['classification'] }) => (
    <Badge className={COLOR_BY_CLASSIFICATION[classification]}>{LABEL_BY_CLASSIFICATION[classification]}</Badge>
)
